import React from "react";
import BrowserFrame from "@/components/BrowserFrame";
import { ArrowRight, CheckCircle2 } from "lucide-react";

/**
 * Visual storytelling: website → booking widget → reservation → PMS sync
 */
export default function BookingFlow() {
  return (
    <div className="grid items-center gap-6 md:grid-cols-[1fr_auto_1fr_auto_1fr]" data-testid="booking-flow">
      {/* 1. Hotel website */}
      <BrowserFrame url="hotel-onufri.al">
        <div className="bg-white p-5">
          <div className="flex items-center justify-between text-[11px]">
            <span className="font-display text-[13px] font-extrabold text-[#0F172A]">Hotel Onufri</span>
            <span className="text-[#64748B]">Dhomat · Galeria · Kontakt</span>
          </div>
          <div className="mt-4 aspect-[5/3] w-full overflow-hidden rounded-md bg-[#F1F5F9]">
            <img
              src="https://images.unsplash.com/photo-1678913308053-316cee77afe9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBob3RlbCUyMHJlc29ydCUyMGV4dGVyaW9yfGVufDB8fHx8MTc3OTg0NDg2NHww&ixlib=rb-4.1.0&q=85"
              alt="Hotel modern në Shqipëri" className="h-full w-full object-cover" loading="lazy" decoding="async"
              width="600" height="360"
            />
          </div>
          <div className="mt-3 flex items-center justify-between rounded-md border border-[#E2E8F0] bg-[#FAFBFC] p-2 text-[11px]">
            <span className="text-[#64748B]">Check-in</span>
            <span className="font-semibold text-[#0F172A]">24 Nën</span>
            <span className="text-[#CBD5E1]">→</span>
            <span className="text-[#64748B]">Check-out</span>
            <span className="font-semibold text-[#0F172A]">27 Nën</span>
            <span className="rounded bg-[#FF7A00] px-2 py-0.5 text-[10px] font-semibold text-white">Kërko</span>
          </div>
        </div>
      </BrowserFrame>

      <div className="hidden flex-col items-center justify-center md:flex">
        <div className="h-px w-6 bg-[#CBD5E1]" />
        <ArrowRight size={18} className="my-1 text-[#FF7A00]" />
        <div className="mono text-[10px] uppercase tracking-wider text-[#94A3B8]">widget</div>
      </div>

      {/* 2. Booking widget */}
      <BrowserFrame url="onufri.akomoda.co" title="Booking Engine">
        <div className="bg-white p-4">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-[#64748B]">Zgjidh dhomën</div>
          <div className="mt-2 space-y-1.5">
            {[
              ["Standard Twin", "€68", true],
              ["Deluxe King", "€92", true],
              ["Suite Premium", "€158", false],
            ].map(([n, p, av]) => (
              <div key={n} className="flex items-center justify-between rounded-md border border-[#E2E8F0] p-2 text-[11px]">
                <div>
                  <div className="font-semibold text-[#0F172A]">{n}</div>
                  <div className="text-[10px] text-[#64748B]">{av ? "I disponueshëm" : "1 dhomë"}</div>
                </div>
                <div className="text-right">
                  <div className="font-display text-[12px] font-bold text-[#0F172A]">{p}</div>
                  <div className="text-[9px] text-[#64748B]">/ natë</div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-3 rounded-md bg-[#FF7A00] p-2 text-center text-[11px] font-semibold text-white">
            Rezervo me €92
          </div>
        </div>
      </BrowserFrame>

      <div className="hidden flex-col items-center justify-center md:flex">
        <div className="h-px w-6 bg-[#CBD5E1]" />
        <ArrowRight size={18} className="my-1 text-[#FF7A00]" />
        <div className="mono text-[10px] uppercase tracking-wider text-[#94A3B8]">PMS</div>
      </div>

      {/* 3. PMS notification */}
      <div className="relative">
        <BrowserFrame url="app.akomoda.co" title="Rezervimi i ri">
          <div className="bg-white p-4">
            <div className="flex items-center gap-2">
              <span className="grid h-7 w-7 place-items-center rounded-md bg-[#DCFCE7] text-[#166534]">
                <CheckCircle2 size={14} />
              </span>
              <div>
                <div className="text-[12px] font-semibold text-[#0F172A]">Rezervim direkt · konfirmuar</div>
                <div className="text-[10px] text-[#64748B]">A. Krasniqi · 3 net · €276</div>
              </div>
            </div>
            <div className="mt-3 space-y-1 text-[10.5px]">
              <div className="flex justify-between rounded-md border border-[#E2E8F0] bg-[#FAFBFC] px-2 py-1.5">
                <span className="text-[#64748B]">Dhoma 201 · Deluxe King</span>
                <span className="font-semibold text-[#0F172A]">24–27 Nën</span>
              </div>
              <div className="flex justify-between rounded-md border border-[#E2E8F0] px-2 py-1.5">
                <span className="text-[#64748B]">Statusi i kanaleve</span>
                <span className="rounded bg-[#DCFCE7] px-1.5 py-0.5 text-[10px] font-semibold text-[#166534]">U përditësua</span>
              </div>
            </div>
          </div>
        </BrowserFrame>
      </div>
    </div>
  );
}
